<template>
  <div>
    <CRow>
      <CCol md="12" class="mb-5">
        <CCard>
          <CCardHeader>
            <CRow>


              <CCol col="4" style="text-align: start">
                <strong>گزارش رانندگان {{ driver_name }}</strong>

              </CCol>
              <CCol col="4" style="text-align: center">
              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="4">
                <treeselect
                    v-model="refer_person"
                    :async="true"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
                />


              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>
              </CCol>
              <CCol col="1">
                <CButton @click="get_lists_buy" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>

            <CDataTableFixed
                :items="items_buy"
                :fields="fields"
                :sorter-value="{column:'masterFactorId', asc:false}"
                :items-per-page="20"
                hover
                @row-clicked="table_row_clicked"

                height="350px"
                sorter
                column-filter

            >
              <template #row="{item}">
                <td>
                  <p style="text-align:center">{{ item.row_id + 1 }}</p>
                </td>
              </template>

              <template #factorDate="{item}">
                <td>
                  <p class="text-center">{{ get_date(item.factorDate) }}</p>
                </td>
              </template>
              <template #referDate="{item}">
                <td>
                  <p class="text-center">{{ get_date(item.referDate) }}</p>
                </td>
              </template>
              <template #signDate="{item}">
                <td>
                  <p class="text-center">{{ get_date(item.signDate) }}</p>
                </td>
              </template>
              <template #masterFactorCode="{item}">
                <td>
                  <p class="text-center">{{ (item.masterFactorCode) }}</p>
                </td>
              </template>


            </CDataTableFixed>

          </CCardBody>

        </CCard>


      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
// import FilterHeader from "../includes/FilterHeader";
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',

  ]
}

Vue.use(VueHtmlToPaper, options);


var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
var items_data = [];


export default {
  name: 'Login',
  components: {
    // FilterHeader,
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      table_clicks:0,
      table_clicks_timer:null,
      show_document: 'test-dynamic',
      start_date: '',
      end_date: '',
      id_checkbox_items: [],
      name: '',
      check_all_exit: false,
      file: '',
      driver_name: '',
      color: '#ffffff',
      previewImage: '',
      submit_refer: 0,
      refer_person: null,
      refer_date: null,
      selected_template: 0,
      description: null,
      items_buy: [],
      items_final: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),

      items_products: [],
      fields: [

        {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'factorDate', label: this.$t('docDate'), _style: 'width:5%'},

        {key: 'masterFactorCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
        {key: 'customerName', label: this.$t('customer'), _style: 'width:10%'},
        {key: 'referDate', label: "تاریخ ارجاع", _style: 'width:10%'},
        // {key: 'payable', label: "پرداخت شده", _style: 'width:10%'},
        {key: 'signDate', label: "تاریخ تحویل", _style: 'width:10%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],

      fields_products: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:3%;padding:0px'},
        {key: 'product', label: this.$t('tables.product'), _style: 'width:20%;padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%;padding:0px'},
        {key: 'weight', label: this.$t('tables.weight'), _style: 'width:7%;padding:0px'},
        {key: 'unit', label: this.$t('tables.unit'), _style: 'width:5%;padding:0px'},

      ],


      details: [],
      templates_items: [
        {template_id: 'One', name: 'A'},
        {template_id: 'Two', name: 'B'},
        {template_id: 'Three', name: 'C'}
      ],
      collapseDuration: 0,
      status_form: 0,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },
    }
  },
  computed: {},
  mounted() {

    this.$root.root_validate_errors = [];
    this.get_lists_buy();

    this.start_date = this.get_day_before_today(1)
    this.end_date = this.get_today()


    bus.$on('delete_confirm_cancel_refer' + this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });


  },
  watch: {},
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)
        this.table_clicks = 0

      }

    },
    get_return_amount(item) {
      if (this.items_return.filter(x => x.masterId == item.masterId).length > 0) {
        return this.items_return.filter(x => x.masterId == item.masterId)[0].amount
      } else {
        return 0;
      }
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },

    print_products() {
      // Pass the element id here
      this.$htmlToPaper('printMe_products');
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists_buy() {
      var self = this;


      const formData = new FormData();

      var url = "GetDriverRpt";


      // formData.append("Status", 0);

      if (this.refer_person != null) {
        // formData.append("FDate", this.refer_date);
        formData.append("PersonId", this.refer_person);
      } else {
        return
      }
      formData.append("FirstDate", this.start_date);
      formData.append("SecondDate", this.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.items_buy = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },


    goShowDocument(item, index) {

window.open('/dashboard/documents/show/' + item.masterFactorId)
    },


  },

}

</script>
